import { FC, ReactNode } from "react";
import { Button, HStack, Icon, Text } from "@chakra-ui/react";

import { CrossIcon, Info2Icon } from "../../icons";

interface IProps {
  message: ReactNode;
  onClose: () => void;
}

export const Toast: FC<IProps> = ({ message, onClose }) => {
  return (
    <HStack
      w="100%"
      py="15px"
      pl="15px"
      pr="11px"
      spacing="10px"
      alignItems="flex-start"
      justifyContent="space-between"
      backgroundColor="gold.50"
      border="1px solid"
      borderColor="gold.500"
      borderRadius="16px"
    >
      <HStack spacing="12px" alignItems="flex-start">
        <Info2Icon color="gold.500" />

        <Text variant="brand" fontSize="14px" lineHeight="19px">
          {message}
        </Text>
      </HStack>

      <Button
        minW="0"
        h="0"
        p={0}
        pl="10px"
        alignItems="flex-start"
        colorScheme="transparent"
        borderRadius="unset"
        onClick={onClose}
      >
        <Icon as={CrossIcon} boxSize="11px" mt="1px" />
      </Button>
    </HStack>
  );
};
